import React from 'react';
import '../styles/maincontent.css';
import Firstpage from './Firstpage';

function Main() {
  return (
    <div className="main-content">
      <Firstpage />
    </div>
  );
}

export default Main;
